// extracted by mini-css-extract-plugin
export default {"bigOrange":"BlockWithExhibitions_bigOrange__r2vHk"};